import { render, staticRenderFns } from "./DownstreamAnalysis.vue?vue&type=template&id=2796196b&"
import script from "./DownstreamAnalysis.vue?vue&type=script&lang=js&"
export * from "./DownstreamAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./DownstreamAnalysis.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DownstreamAnalysis.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports